import { markCommonImported } from './commonTracker';
if (process.env.NODE_ENV === 'development') {
    markCommonImported();
}
import './common.css';
import '../atoms/atoms';
